<template>
	<search-list :pageSizes="[1000]" ref="sl" :where="where" :searchKeys="searchKeys" api-path="/impLog/list"  notSearchAll  >
		<mm-lc title="Date">
			<el-date-picker v-model="where.date" type="date" editable:="false" value-format="yyyy-MM-dd" />
		</mm-lc>
        <mm-lc title="Channel">
			<mm-channel-select v-model="where.channel_id"/>
		</mm-lc>
		<mm-table slot="dataTable" slot-scope="res" :res="res">

			<el-table-column label="Date" prop="date"/>
            <el-table-column label="Offer Id" prop="offer_id" key="offer_id">
				<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offer_id" :row_name="sp.row.offer_id"/>
			</el-table-column>
			<el-table-column label="Adv Name" prop="adv_name"/>

			<el-table-column label="Offer Name" prop="offer_name"/>
			<el-table-column label="ChannelId" prop="channel_id"/>
			<el-table-column label="Channel" prop="aff_id">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.channel_name" :row_id="sp.row.channel_id" row_type="channel" />
			</el-table-column>
			<el-table-column label="Impressions" prop="count"/>
			
		</mm-table>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			offer_id: { label: "Offer Id" },
		};
		const days = [];
		for (let i = 0; i <= 7; i++) {
			days.push(i);
		}
		return {
			where: {
				date: new Date().toISOString().substr(0,10),
			},
			days,
			searchKeys,
            
		};
	},
	methods: {
		timeFormat(date) {
			if (!date || date.length === 0) {
				return '';
			}
			let result = [];
			date.sort();
			for (let d of date) {
				d = new Date((d + 8 * 3600) * 1000);
				let hour = d.getUTCHours();
				hour = hour < 10 ? '0' + hour : hour;
				result.push(hour);
			}
			return result.join(',');
		},
		getDate(day) {
			const date = new Date(new Date().setUTCHours(0) - day * 24 * 3600000);
			const m = date.getUTCMonth() + 1;
			const d = date.getUTCDate();
			return m + '-' + d;
		},

	}
};
</script>

<style scoped>
.edit-camp {
	width: 400px;
	height: 500px;
}
.el-form-item {
	width: 500px;
}
.search-condition {
	display: flex;
	flex-direction: column;
}
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;

}
</style>


